module.exports = " <div class=list _v-588d5c74=\"\"> <div class=items _v-588d5c74=\"\"> <container _v-588d5c74=\"\"> <row justify-content=center _v-588d5c74=\"\"> <column :size=24 _v-588d5c74=\"\"> <slot _v-588d5c74=\"\"></slot> </column> </row> </container> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-588d5c74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/List.vue
// module id = 760
// module chunks = 2